import * as React from 'react';
import { Api } from '../../../typings/api';
import { ItemInfos, ItemLabel, ItemSubLabel } from './styles';
import { Translate } from 'react-redux-i18n';
import ListItemActionButton from '../../../containers/ListItem/ActionButton';
import ListItemDownloadStatus from '../DownloadStatus';
import ListItemProposalStatus from '../ProposalStatus';
import DriveItemUtils from '../../../utils/driveItem';

interface ListItemInfosProps {
	driveItemType: Api.DriveItemType | undefined;
	publicationFormat: Api.PublicationFormat | undefined;
	driveItemId?: number;
	proposalStats: Api.ProposalData | undefined;
	hasActionButton: boolean;
	label: string;
	isRowView: boolean;
	isActiveIcon: boolean;
	onContextualMenuHover: (e: MouseEvent) => void;
	isUpToDate: boolean;
	isUpdatable: boolean;
}

const ListItemInfos = (props: ListItemInfosProps) => {
	const {
		label, driveItemType, driveItemId, isUpToDate, isUpdatable, proposalStats,
		hasActionButton, isActiveIcon, isRowView, onContextualMenuHover, publicationFormat
	} = props;

	const resolvedDriveItemType = driveItemType ? driveItemType : Api.DriveItemType.Directory;
	const driveItemTypeKey = DriveItemUtils.getAssetTypeTranslationKey(resolvedDriveItemType, publicationFormat);

	return (
		<ItemInfos isRowView={isRowView}>
			<ItemLabel isRowView={isRowView}>{label}</ItemLabel>
			<ItemSubLabel isRowView={isRowView}>
				<Translate value={driveItemTypeKey} />
				{proposalStats && <ListItemProposalStatus
					stats={proposalStats}
				/>}
			</ItemSubLabel>
			<ListItemDownloadStatus
				isUpToDate={isUpToDate}
				isUpdatable={isUpdatable}
				isRowView={isRowView}
			/>
			{hasActionButton && driveItemId && (
				<ListItemActionButton
					isRowView={isRowView}
					driveItemId={driveItemId}
					onContextualMenuHover={onContextualMenuHover}
					isActiveIcon={isActiveIcon}
				/>
			)}
		</ItemInfos>
	);
};

export default ListItemInfos;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ListItem/Infos/index.tsx